/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface Pagination<T = any> {
  data: T[];
  count: number;
  total: number;
  page: number;
  pageCount: number;
}

export type PaginationCount = Pick<Pagination, 'count' | 'page' | 'pageCount'>;

interface IPreviousPagination<T = any> {
  items: T[];
  itemCount: number;
  totalItems: number;
  pageCount: number;
}

@Injectable({
  providedIn: 'root'
})
export class PaginationInterceptor implements HttpInterceptor {
  // Make sure to exclude any endpoints that should not be paginated here.
  // @todo: Specify exact endpoints to paginate, rather than broadly matching and excluding.
  private _excludedEndpoints = /availability|integrations\/google\/calendar/;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && (event.body?.pageCount || (event.body?.items && !req.url.match(this._excludedEndpoints)))) {
          event = event.clone({ body: this.mapPagination(event.body) });
        }
        return event;
      })
    );
  }

  /**
   * Method - map pagination
   * @param pagination - pagination
   * map old pagination model to new model
   */
  private mapPagination(result: Pagination | IPreviousPagination): Pagination {
    if ('items' in result) {
      return {
        data: result.items,
        count: result.itemCount,
        total: result.totalItems,
        // previous endpoint doesn't provide that information
        page: null,
        pageCount: result.pageCount
      };
    }

    return result;
  }
}
